import { Link } from "react-router-dom";
import { base_url } from "../../../constants";
import { recuadroIndividualDTO } from "../../../models/Colecciones.model";
import Subcoleccion from "./subcoleccion";

export default function RecuadroIndividual(props: recuadroIndividualDTO){
    let subcoleccion = props.hijos  
    const posicion = (props.columna < 3)?'show_div_right':'show_div_left'
    const texto = (props.columna < 3)?'<i class="d-none d-md-block fa-solid fas fa-caret-right text-white pe-3"></i><p class="px-2">'+props.titulo+'</p><i class="d-block d-md-none fa-solid fa-caret-down text-white ps-3"></i>'
    :'<i class="d-none d-md-block fa-solid fas fa-caret-left text-white pe-3"></i><p class="px-2">'+props.titulo+'</p><i class="d-block d-md-none fa-solid fa-caret-down text-white ps-3"></i>'

    if(subcoleccion?.length){
        return(        
            <div className="info_div" style={{"height": props.asignaTamanio}}>
                    <div className="square_collection text-center justify-content-center ms-lg-2" style={{"height": props.asignaTamanio}} data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="collapseExample"
                    dangerouslySetInnerHTML={{ __html: texto }} 
                    />                
                <div className={`${posicion} col-12 collapse`} id="collapseExample">
                    { 
                        subcoleccion?.map( (subcol) =>                
                            {     
                                return <Subcoleccion key={subcol.id} titulo={subcol.titulo} id={subcol.id}/>                                         
                            }             
                        )
                    }
                </div>
            </div>
        )
    }else{
        return(            
            <div className="">
                <Link to={`/${base_url}/colecciones/${props.id}`}>
                    <div className="square_collection text-center justify-content-center mx-0 ms-md-2" style={{"height": props.asignaTamanio}}>
                        <p className="px-2"><div dangerouslySetInnerHTML={{__html: `${props.titulo}` }}></div> </p>  
                    </div>
                </Link>
            </div>
        );
    }
}
{/* <div class="info_div" style="height: 125px;">
    <div class="square_collection text-center justify-content-center ms-lg-2" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="collapseExample" style="height: 125px;">
        <i class="d-none d-md-block fa-solid fas fa-caret-left text-white pe-3"></i><p class="px-2">Fuera de Coleccion</p><i class="d-block d-md-none fa-solid fa-caret-down text-white ps-3"></i>
    </div>
    <div class="show_div_left col-12 collapse" id="collapseExample">
        <a href="/editorial_uat/colecciones/34">
        <div class="square_collection_sub text_white justify-content-center">test</div>
        </a>
        <a href="/editorial_uat/colecciones/35">
            <div class="square_collection_sub text_white justify-content-center">test2</div>
        </a>
    </div>
</div> */}
